import type { FC } from 'react';
import { Button, Flex, Icon, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { usePageContext } from 'vike-react/usePageContext';
import { getAuthUrlWithRedirect } from '@/utils/getAuthUrlWithRedirect';
import { getLinkHref } from '@/utils/getLinkHref';

export const UnauthorizedStub: FC = () => {
    const { t } = useTranslation();
    const pageContext = usePageContext();

    return (
        <>
            <Icon.LockOpen size={72} color="iconMain" />
            <Flex vertical align="center" gap={16}>
                <Typography.Heading level={2}>{t('Apply_Unauthorized_Stub_Title')}</Typography.Heading>
                <Typography.Paragraph level={1}>{t('Apply_Unauthorized_Stub_Description')}</Typography.Paragraph>
            </Flex>
            <Button href={getAuthUrlWithRedirect(getLinkHref(pageContext, '/apply'))} size="m">
                {t('Apply_Unauthorized_Stub_Button')}
            </Button>
        </>
    );
};
